// AUTO-GENERATED GraphQL Builder for BookingDispute
import * as Builders from '../';
export class BookingDisputeBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  bookingId(){ return this.add('bookingId'); }
  raisedByCustomerId(){ return this.add('raisedByCustomerId'); }
  reasonCode(){ return this.add('reasonCode'); }
  reason(){ return this.add('reason'); }
  raisedDate(){ return this.add('raisedDate'); }
  heldAtRaise(){ return this.add('heldAtRaise'); }
  status(){ return this.add('status'); }
  resolution(){ return this.add('resolution'); }
  vendorAmount(){ return this.add('vendorAmount'); }
  customerAmount(){ return this.add('customerAmount'); }
  resolutionNote(){ return this.add('resolutionNote'); }
  resolvedDate(){ return this.add('resolvedDate'); }
  resolvedBy(){ return this.add('resolvedBy'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  booking(b?:(q:Builders.BookingBuilder)=>void){
    if(this.depth>=5||this.v.has('booking'))return this;
    this.v.add('booking');
    const n=new Builders.BookingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`booking { ${inner} }`);
    return this;
  }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  raisedByCustomer(b?:(q:Builders.CustomerBuilder)=>void){
    if(this.depth>=5||this.v.has('raisedByCustomer'))return this;
    this.v.add('raisedByCustomer');
    const n=new Builders.CustomerBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`raisedByCustomer { ${inner} }`);
    return this;
  }

  resolvedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('resolvedByUser'))return this;
    this.v.add('resolvedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resolvedByUser { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }
}
